import styled from "styled-components";

export const FlexCenter = styled.div`
  display: flex;
  width: max-content;
  justify-content: center;
  align-items: center;
  flex-flow: column nowrap;
`;
